var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages && _vm.messages.length > 0)?_c('div',_vm._l((_vm.messages),function(item,index){return _c('item',{key:index,attrs:{"data":item,"previewData":_vm.previewData}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }